import React from 'react';
import { useParams } from 'react-router';
import TestDataList from '../projects/TestDataList';
import { Breadcrumbs, PageScaffold } from '../ui';

const TestDataWorkspace = () => {
  const { project_id } = useParams();
  return (
    <PageScaffold
      title="Test Data"
      description="Manage reusable test data profiles for this project."
      breadcrumbs={<Breadcrumbs items={[{ label: 'Configure' }, { label: 'Test Data' }]} />}
    >
      <div className="rt-legacy-embed rt-testdata-embed">
        <TestDataList key={project_id} />
      </div>
    </PageScaffold>
  );
};

export default TestDataWorkspace;
